import _ from "lodash";
import * as echarts from "echarts";
import {levelMap, scoreMap} from "../common";

/**
 * 换肤加class函数
 * @param className
 */
export const toggleClass = (className) => {
  document.body.className = className;
};

/**
 * 风险等级
 * @param val
 * @returns {{color: string, level: number, name: string}}
 */
export const getThreatLevel = (val) => {
  if (val > 80) {
    return scoreMap[0];
  } else if (val > 60) {
    return scoreMap[1];
  } else if (val > 40) {
    return scoreMap[2];
  } else if (val > 20) {
    return scoreMap[3];
  }
  return scoreMap[4];
};

/**
 * 事件等级
 * @param val
 * @returns {*}
 */
export const getEventLevel = (val) => {
  return val ? _.filter(levelMap, ["code", val])[0] : [];
};

export const getDateTimeList = (list, name) => {
  let dateTimeList = [], valueList = [];

  list.forEach(item => {
    let arr = Object.entries(item)[0];

    dateTimeList.push(arr[0]);
    valueList.push({
      name: arr[0],
      value: arr[1]
    });
  });
  return {
    dateTimeList: dateTimeList,
    dataInfo: [{name: name, valueList: valueList}]
  };
};

export const setRankStyle = (index) => {
  return {
    shadowColor: scoreMap[index] ? scoreMap[index].color : scoreMap[index - scoreMap.length].color,
    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
      offset: 0,
      color: scoreMap[index] ? scoreMap[index].gradient : scoreMap[index - scoreMap.length].gradient
    }, {
      offset: 1,
      color: scoreMap[index] ? scoreMap[index].color : scoreMap[index - scoreMap.length].color
    }])
  };
};

export const setEntry = (data) => {
  return data.map(item => {
    let arr = Object.entries(item)[0];

    return {
      name: arr[0],
      value: arr[1]
    };
  });
};
